export default "__VITE_ASSET__FESXeuqF__"